import { useContent } from '../ContentContext';
import { PageHero } from '../components/Common';

// Privacy Policy — required for the Play Store / App Store listing.
export default function PrivacyPolicy() {
  const { company = {} } = useContent();
  const email = company.email || 'support@goldentajrice.com';
  const name = company.name || 'Golden Taj Rice';
  const updated = 'September 2026';

  return (
    <>
      <PageHero title="Privacy Policy" />

      <section>
        <div className="container legal-page">
          <p className="muted">Last updated: {updated}</p>

          <p>
            This Privacy Policy explains how {name} (“we”, “us”, “our”) collects, uses and protects your
            information when you use our mobile app and website. By using our services you agree to this policy.
          </p>

          <h3>Information we collect</h3>
          <ul>
            <li><b>Account details</b> — your name, mobile number and email address.</li>
            <li><b>Delivery details</b> — the addresses and PIN codes you save to receive orders.</li>
            <li><b>Order information</b> — the products you order, order history and payment status.</li>
            <li><b>Support content</b> — messages, ratings, reviews and any media you send us.</li>
            <li><b>Device &amp; usage data</b> — basic technical information needed to run the app reliably.</li>
          </ul>

          <h3>How we use your information</h3>
          <ul>
            <li>To create and manage your account and log you in via OTP.</li>
            <li>To process, price and deliver your orders to your location.</li>
            <li>To provide customer support, coupons, rewards and order updates.</li>
            <li>To improve our products, services and app experience.</li>
          </ul>

          <h3>Payments</h3>
          <p>
            Online payments are processed securely by our payment partner (Razorpay). We do not store your
            card, UPI or banking credentials on our servers.
          </p>

          <h3>Sharing your information</h3>
          <p>
            We do not sell your personal information. We share it only as needed to run the service — for
            example with delivery partners to fulfil your order, and with payment providers to process
            payments — and where required by law.
          </p>

          <h3>Data retention &amp; security</h3>
          <p>
            We keep your information for as long as your account is active or as needed to provide the
            service and meet legal obligations. We use reasonable technical and organisational measures to
            protect it. You can request deletion of your account and data at any time (see our{' '}
            <a href="/delete">Account &amp; Data Deletion</a> page).
          </p>

          <h3>Your rights</h3>
          <p>
            You may access, correct or delete your personal information, and withdraw consent, by managing
            your profile in the app or by contacting us at{' '}
            <a href={`mailto:${email}`}>{email}</a>.
          </p>

          <h3>Children</h3>
          <p>Our services are intended for users aged 18 and above and are not directed at children.</p>

          <h3>Changes to this policy</h3>
          <p>
            We may update this policy from time to time. Material changes will be reflected on this page with
            a new “Last updated” date.
          </p>

          <h3>Contact us</h3>
          <p>
            For any privacy questions, contact {name} at{' '}
            <a href={`mailto:${email}`}>{email}</a>
            {company.address ? <> · {company.address}</> : null}.
          </p>
        </div>
      </section>
    </>
  );
}
